<template>
  <div class="spotlight-inner-wrapper">
    <div class="confirmation-hero text-center mb-5">
      <img
        class="my-3 message-icon"
        :src="require(`@/assets/comments-alt-bg.svg`)"
        alt="Comment icon"
        width="48"
        height="43"
      />
      <h2 class="mt-0">{{ $t('message.spotlight.sxm.confirmation.title') }}</h2>
      <p>{{ $t('message.spotlightV2.getReportForm.sentText') }}</p>
    </div>
    <CTA />
  </div>
</template>

<script>
import CTA from '@/components/ProductCTAs.vue';

export default {
  name: 'Confirmation',
  components: {
    CTA,
  },
};
</script>

<style scoped lang="scss">
.message-icon {
  width: 54px;
  height: 48px;
  margin-bottom: 24px;
}
</style>
